import UserTagsPanel from './UserTagsPanel';

export default UserTagsPanel;
